import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { instance } from '@viz-js/viz';
import useClickOutside from '../../components/useOutsideClick';
//@ts-ignore
import Papa from 'papaparse'
import * as d3 from 'd3'

const scrollName = 'family-treescrollgen3'
interface scrollJSON {
    [key: string]: any
}
let scrollJSON: scrollJSON | null = null

interface Props {
    targetScroll: string,
    filterFamily: string,
    filterExec: string,
    filterPledgeClass: string,
    setFilterFamily: React.Dispatch<React.SetStateAction<string>>,
    setFilterExec: React.Dispatch<React.SetStateAction<string>>,
    setFilterPledgeClass: React.Dispatch<React.SetStateAction<string>>,
}

export interface FullTreeRef {
    adjustTreeBrightness: (brightness: number, opacity: number, edgeFactor: number) => void
}

const FullTree = ({targetScroll, filterFamily, filterExec, filterPledgeClass, setFilterFamily, setFilterExec, setFilterPledgeClass}: Props) => {
    const [graphData, setGraphData] = useState<string | null>(null)
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [nodePos, setNodePos] = useState([0, 0])
    const [darkenedTree, setDarkenedTree] = useState<Boolean>(false)
    const svgRef = useRef<SVGSVGElement | null>(null)

    const [scroll, setScroll] = useState<String | null>(null)
    const [family, setFamily] = useState<String | null>(null)
    const [selectedScroll, setSelectedScroll] = useState<string[]>([])

    //useClickOutside(svgRef.current?.querySelectorAll('g.node'), () => {
        //console.log('Clicked outside the tree')
        //setDarkenedTree(false)
    //})

    useClickOutside(svgRef, 'tree-div', () => {
        console.log('clicked outside.')
        adjustTreeBrightness(1, 1, 1)
        setFilterExec('')
        setFilterFamily('')
        setFilterPledgeClass('')
    })
    
    // FILTER LOGIC
    useEffect(() => {
        if (svgRef.current && scrollJSON) {

            // AND-based filter
            if (filterExec || filterFamily || filterPledgeClass) { 
                // Begin by dimming tree
                adjustTreeBrightness(.8, .5, 0.5) 
                // Apply filters
                // (
                    // ((filterExec == [execposition] && scrolljsonexec == 'yes') OR filterExec=='nofilter') 
                    // AND ((filterFamily == 'nofilter' || scrollJSON![node.id]['Family'].toLowerCase().trim() == filterFamily)) 
                    // AND ((filterPledgeClass == 'nofilter' || scrollJSON![node.id]['Nom. Pledge Class'].toLowerCase().trim() == filterPledgeClass))
                //)
                console.log(`Exec: ${filterExec} Family: ${filterFamily}, PC: ${filterPledgeClass} filter(s) selected...`)
                svgRef.current!.querySelectorAll('g.node').forEach(node => {
                    try {
                        if (!node.id.includes('node')) {
                            if (
                                (filterFamily == 'nofilter' || scrollJSON![node.id]['Family'].toLowerCase().trim() == filterFamily) 
                                && (filterPledgeClass == 'nofilter' || scrollJSON![node.id]['Nom. Pledge Class'].toLowerCase().trim() == filterPledgeClass)
                                && (filterExec == 'nofilter' || 
                                    (filterExec == 'prytanis' && scrollJSON![node.id]['Prytanis?'].toLowerCase().trim() == 'yes') || 
                                    (filterExec == 'epiprytanis' && scrollJSON![node.id]['Epipryt.?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'hypophetes' && scrollJSON![node.id]['Hypo.?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'hegemon' && scrollJSON![node.id]['Heg?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'pylortes' && scrollJSON![node.id]['Pylo.?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'histor' && scrollJSON![node.id]['Histor?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'grammateus' && scrollJSON![node.id]['Gram.?'].toLowerCase().trim() == 'yes') ||
                                    (filterExec == 'crysophylos' && scrollJSON![node.id]['Cryso.?'].toLowerCase().trim() == 'yes')
                                )
                            ) {
                                adjustNodeBrightness(1, 1, node)
                            }
                        }
                    } catch {console.error(`Filter failed: ${node.id}`)}
                })
            }
        }
    }, [filterExec, filterFamily, filterPledgeClass])

    const fetchGraph = async () => {
        if (graphData) return
        try {
            const dotfilePath = `https://server.duplantis.org/fraternity/tree`
            const scrollPath = `https://server.duplantis.org/fraternity/scroll`
            const response = await fetch(dotfilePath, { headers: { 'jwt-token': localStorage.getItem('jwt-token') || '' } })
            const scrollResponse = await fetch(scrollPath, { headers: { 'jwt-token': localStorage.getItem('jwt-token') || '' } })
            const scrollText = await scrollResponse.text()
            console.log(scrollText)
            const scrollArray = Papa.parse(scrollText, { header: true }).data
            scrollJSON = Object.fromEntries(scrollArray.map((row: any) => [row.Scroll, row]))
            console.log(scrollJSON)

            if (!response.ok) { console.error(`Failed to fetch graph data: ${response.statusText}`) }
            
            return await response.text()
        } catch(e) {console.error(e)}
    }

    const graphvizRender = async (graphData: string) => {
        //console.log(`Attempting to render: ${graphData}`)
        const viz = await instance()
        const svgElement = await viz.renderSVGElement(graphData)
        if (svgRef.current) {
            svgRef.current.innerHTML = svgElement.innerHTML
            
            const svg = d3.select(svgRef.current)
            const g = svg.select('g#graph0')

            g.attr("transform", null);

            const zoomBehavior = d3.zoom<SVGSVGElement, unknown>()
                .scaleExtent([.9, 5])
                .on("zoom", (event) => {
                    g.attr("transform", event.transform.toString());
                })

            svg.call(zoomBehavior)
            
            const bbox = svgRef.current.getBBox()
            if (bbox.height == 0) {
                console.error(`the bbox has a height of ${bbox.height}`)
            }

            svgRef.current!.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`)
            svgRef.current!.setAttribute('width', `${bbox.width}`);
            svgRef.current!.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            setIsLoaded(true)
            svgRef.current.querySelectorAll('g.node').forEach(node => {
                node.addEventListener('click', async () => {
                    // For each node, select its children and darken them
                    //await setDarkenedTree(true)
                    const lineageScrolls = await getLineageScrolls(graphData, node.id)
                    if (scrollJSON) {
                        //(node as HTMLElement).style.filter = 'brightness(0.75)'
                        adjustTreeBrightness(1, 0.5, .5)
                        svgRef.current?.querySelectorAll('g.node').forEach(node => {
                            if (lineageScrolls.includes(node.id)) {
                                adjustNodeBrightness(1, 1, node)
                            }
                        })
                        adjustNodeBrightness(1, 1, node)
                        
                        //setScroll(node.id)
                        //alert(`Node clicked: ${node.id.trim()}: ${scrollJSON[node.id]["Last Name"]}`)
                    }
                });
            });
        }
    }

    const graph = async () => {
        if (svgRef) {
            const graphResponse = await fetchGraph()
            setGraphData(graphResponse ?? null)
            if (graphResponse) {
                if (!svgRef.current) return
                try {
                    console.log("Rendering graph...")
                    svgRef.current.innerHTML = '' // Clear previous content
                    await graphvizRender(graphResponse)
                    console.log("Completed rendering graph.")
                    
                } catch (e) {
                    console.error("ERROR during renderGraph():", e)
                }
            } else { console.error('Failed to fetch graph data.') }
        }
    }//

    const adjustTreeBrightness = (brightness: number, opacity: number, edgeFactor: number) => {
        if (svgRef.current) {
            svgRef.current?.querySelectorAll('g.node').forEach(node => {
                (node.querySelectorAll('*').forEach(child => {
                    (child as HTMLElement).style.transition = 'filter 0.5s ease, -webkit-filter 0.5s ease';
                    (child as HTMLElement).style.transition = 'opacity 0.5s ease';
                    (child as HTMLElement).style.filter = `brightness(${brightness})`;
                    (child as HTMLElement).style.opacity = `${opacity}`
                }))
            })
            svgRef.current?.querySelectorAll('g.edge').forEach(node => {
                (node.querySelectorAll('*').forEach(child => {
                    (child as HTMLElement).style.transition = 'filter 0.5s ease, -webkit-filter 0.5s ease';
                    (child as HTMLElement).style.transition = 'opacity 0.5s ease';
                    (child as HTMLElement).style.filter = `brightness(${brightness * edgeFactor})`;
                    (child as HTMLElement).style.opacity = `${opacity * edgeFactor}`
                }))
            })
        }
    }

    const adjustNodeBrightness = (brightness: number, opacity: number, node: Element) => {
        node.querySelectorAll('*').forEach(child => {
            (child as HTMLElement).style.transition = 'filter 0.3s ease-in-out';
            (child as HTMLElement).style.transition = 'opacity 0.3s ease-in-out';
            (child as HTMLElement).style.filter = `brightness(${brightness})`;
            (child as HTMLElement).style.opacity = `${opacity}`
        });
    }

    // Darkening effect
    useEffect(() => {
        adjustTreeBrightness(0.9, 0.6, 0.5)
        if (!darkenedTree) {
            adjustTreeBrightness(1, 1, 1)
        }
    }, [darkenedTree])

    useEffect(() => {
        if (svgRef.current) {
            graph()
        }
    }, [targetScroll])

    // Prevent non-svg zoom
    useEffect(() => {
        const preventZoom = (e: WheelEvent) => {
          if (e.ctrlKey) {
            e.preventDefault(); // blocks ctrl+scroll zoom
          }
        };
        window.addEventListener('wheel', preventZoom, { passive: false });
        return () => {
          window.removeEventListener('wheel', preventZoom);
        };
    }, []);

    const BioTab = () => {
        let first, last, firstLast, hometown, pledgeClass, prytanisLabel, hegemonLabel, region, majors, headshotURL, headshot
        prytanisLabel = <span></span>
        hegemonLabel = <span></span>
        first = '[FIRST]'
        last = '[LAST]'
        firstLast = `${first} ${last}`
        pledgeClass = 'NULL'
        hometown = '[HOMETOWN]'
        region = '[REGION]'
        majors = ['MAJOR ONE', 'MAJOR TWO', 'MAJOR THREE']
        headshotURL = `/headshots/MIA.jpg`
        headshot = <img className='w-4/5 h-32 border' src={headshot} alt="" />

        if (scrollJSON && scroll) {
            first = scrollJSON![Number(scroll)]['First Name']
            last = scrollJSON![Number(scroll)]['Last Name']
            firstLast = `${first} ${last}`

            if (scrollJSON![Number(scroll)]['Nom. Pledge Class'] == 'Honorary') {
                pledgeClass = <span><i>Honorary</i></span>
            } else {
                let pledgeClassLetters = scrollJSON![Number(scroll)]['Nom. Pledge Class'].split(' ')
                let splitPledgeClass = pledgeClassLetters.map((letter: string) => '&' + letter + ';');
                pledgeClass = <span dangerouslySetInnerHTML={{ __html: splitPledgeClass.join('') }} />
            }

            if (scrollJSON![Number(scroll)]['Prytanis?'] == 'Yes') {
                prytanisLabel = <span> &#x2654; </span>
            }

            if (scrollJSON![Number(scroll)]['Heg?'] == 'Yes') {
                hegemonLabel = <span> &#x2620; </span>
            }
            majors = ['']
        }
        
        return (<>
            <div className='hidden flex h-full w-1/5 bg-white z-20 absolute bottom-0 left-[-8px] opacity-98 border border-orange-950/75 rounded-lg'>
                <div className='flex flex-col w-full h-full bg-orange-100/50 rounded-lg items-center justify-center space-y-1 p-6 pl-8'>
                    <div className='w-full items-center'>{headshot}</div>
                    <p className='text-orange-950/75 font-semibold text-xl'>{firstLast}</p>
                    <p className='text-orange-950/75 font-semibold text-xl font-symbola'>
                        <span>{`#${scroll}`} </span>
                        <span>{pledgeClass}</span>
                        <span>{prytanisLabel}</span>
                        <span>{hegemonLabel}</span>
                    </p>
                    <p className='text-orange-950/75'>{`${hometown}, ${region}`}</p>
                    <p className='text-orange-950/75 text-sm italic text-center'>{`${majors!.join(', ')}`}</p>
                    <p className='text-orange-950/75 text-xs text-justify'> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent molestie molestie lectus. Morbi vel mollis metus. Vivamus euismod tellus ut ipsum fermentum consectetur. In hac habitasse platea dictumst. Duis nec ante ac ex sagittis vehicula. Sed eget aliquam lectus. Vestibulum eget interdum arcu. Aliquam ut porta risus, vitae facilisis nulla. Fusce et ligula sem. Fusce pellentesque metus sit at. </p>
                </div>
            </div>
        </>)
    }

    return (<>
        <BioTab />
        <svg id='family-tree-svg' ref={svgRef} className={`ml-4 mr-4 transition-opacity duration-1000 ease-in-out ${isLoaded ? 'opacity-100' : 'opacity-0'}`}></svg>
    </>);
}

export default FullTree

function getLineageScrolls(graph: any, targetScroll: string) {
    let graphRows = removeDuplicates(graph)
    // create array with targetScroll
    let upperLineageScrolls = [targetScroll]
    let lowerLineageScrolls = [targetScroll]
    
    // Iterate through the cleaned dot file row by row downwards
    //console.log(`--- starting with lower ${lowerLineageScrolls} ---`)
    for (let i = 0; i < graphRows.length; i++) {
        let newLineageScroll: string = ''
        //let knownLineageScroll: string = ''
        // Check each known lower lineage scroll against the row
        for (let j = 0; j < lowerLineageScrolls.length; j++) {
            if (graphRows[i].trim().startsWith(`${lowerLineageScrolls[j]} ->`)) {
                const knownLineageScroll = lowerLineageScrolls[j]
                console.log(`"${graphRows[i].trim()} starts with ${knownLineageScroll}"`)
                newLineageScroll = graphRows[i].slice(knownLineageScroll.length + 5)
                console.log(`Adding ${newLineageScroll} to lower: ${lowerLineageScrolls}`)
                break
            }
        }
        if (newLineageScroll !== '' && Number(targetScroll) < Number(newLineageScroll)) { lowerLineageScrolls.push(newLineageScroll) }
    }

    // Moving upwards
    //console.log(`--- starting with upper ${upperLineageScrolls} ---`)
    for (let i = graphRows.length - 1; i > 0; i--) {
        let newLineageScroll: string = ''
        //let knownLineageScroll: string = ''
        // Check each known upper lineage scroll against the row
        for (let j = 0; j < upperLineageScrolls.length; j++) {
            if (graphRows[i].includes(`-> ${upperLineageScrolls[j]}`)) { 
                const knownLineageScroll = upperLineageScrolls[j]
                console.log(`"${graphRows[i].trim()} ends with ${knownLineageScroll}"`)
                newLineageScroll = graphRows[i].slice(1, graphRows[i].search(' -> '))
                console.log(`Adding ${newLineageScroll} to upper: ${upperLineageScrolls}`)
                break
            }
        }
        if (newLineageScroll !== '') {upperLineageScrolls.push(newLineageScroll) }
    }
    const lineageScrolls = lowerLineageScrolls.concat(upperLineageScrolls.slice(1))
    return lineageScrolls
}

// removing duplicates
function removeDuplicates(graph: any) {
    let graphRows = graph.split('\n')
    for (let i = 0; i < graphRows.length; i++) {
        if (graphRows[i+1] == graphRows[i]) {
            graphRows[i] = ''
        }
    }
    return graphRows.filter((row: string) => row !== '')
}

// Outside click collapse handler
/*
function useClickOutsideSVG(svg: any) {
    useEffect(() => {
        //Invoke Function onClick outside of element
        function handleClickOutside(event: any) {
            if (svg.current && !svg.current.contains(event.target)) {
                console.log('clicked outside...')
                adjustTreeBrightness(1, 1)
            }
        }
        // Bind
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // dispose
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [svg]);
}
*/